"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityActions = exports.EntityActionsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var use_entities_1 = require("../../hooks/use-entities");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var use_modal_1 = require("../../hooks/use-modal");
var person_photo_1 = require("./person-photo");
var icon_button_1 = require("../elements/icon-button");
var entity_type_icon_1 = require("./entity-type-icon");
var sprintf_js_1 = require("sprintf-js");
exports.EntityActionsDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), theme_1.theme.COLOR('app-chrome'))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n    display: flex;\n    padding: ", " ", ";\n    background: ", ";\n    margin-left: ", ";\n    font-weight: 500;\n    text-transform: capitalize;\n    color: ", ";\n    ", ";\n    text-decoration: none;\n    align-items: center;\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n  "], ["\n    flex-wrap: nowrap;\n    display: flex;\n    padding: ", " ", ";\n    background: ", ";\n    margin-left: ", ";\n    font-weight: 500;\n    text-transform: capitalize;\n    color: ", ";\n    ", ";\n    text-decoration: none;\n    align-items: center;\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(10), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'), theme_1.theme.COLOR('dark'), theme_1.theme.FILL('dark'))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    align-items: center;\n    display: flex;\n    text-decoration: none;\n    margin: 0;\n\n    b {\n      color: ", ";\n    }\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    align-items: center;\n    display: flex;\n    text-decoration: none;\n    margin: 0;\n\n    b {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.COLOR('primary'))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n  "])))
});
var PhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    list-style: none;\n    margin: 0;\n    padding-left: ", ";\n    margin-left: ", ";\n    font-size: ", ";\n    display: flex;\n    flex-wrap: wrap;\n  "], ["\n    ", ";\n    list-style: none;\n    margin: 0;\n    padding-left: ", ";\n    margin-left: ", ";\n    font-size: ", ";\n    display: flex;\n    flex-wrap: wrap;\n  "])), theme_1.theme.DOT_BG('v'), theme_1.theme.UNIT(1), theme_1.theme.UNIT(2.5), theme_1.theme.FONT_SIZE(15))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    background-position: left center;\n    margin: ", " 0;\n  "], ["\n    ", ";\n    background-position: left center;\n    margin: ", " 0;\n  "])), theme_1.theme.DOT_BG('h'), theme_1.theme.UNIT(1))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled_components_1.default.header(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Title: styled_components_1.default.h1(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Photo: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Body: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Items: styled_components_1.default.ul(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled_components_1.default.li(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Link: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Icon: (0, styled_components_1.default)(entity_type_icon_1.EntityTypeIcon)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var EntityActions = function (props) {
  var className = props.className,
    entity = props.entity;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var detailsChildren = (0, use_app_screen_1.useAppScreen)().detailsChildren;
  var person = (0, use_active_person_1.useActivePerson)().person;
  var entities = (0, use_entities_1.useEntities)();
  var modal = (0, use_modal_1.useModal)();
  var t = (0, use_lang_1.useLang)();
  var Icons = (0, use_icons_1.useIcons)();
  // select all children who have an entityTypeName
  // we may need a more concrete way to identify this later 
  var children = detailsChildren.filter(function (child) {
    return !!child.entityTypeName;
  });
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Header, null, react_1.default.createElement(My.Title, null, react_1.default.createElement(My.Photo, {
    size: 24,
    entity: person
  }), (0, sprintf_js_1.sprintf)(t('Contribute to this %s'), definition.label))), react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Items, null, children.map(function (ec, index) {
    var Icon = Icons.Entities[ec.entityTypeName];
    var defn = entities[ec.entityTypeName];
    if (defn) {
      return react_1.default.createElement(My.Item, {
        key: index
      }, react_1.default.createElement(My.Link, {
        icon: Icon && react_1.default.createElement(Icon, null),
        onClick: function () {
          modal.show(react_1.default.createElement("div", null, "Hey it's modal"));
        }
      }, (0, sprintf_js_1.sprintf)(t('Add %s'), defn.label)));
    }
  }))));
};
exports.EntityActions = EntityActions;
exports.EntityActions.defaultProps = exports.EntityActionsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;